// Industries served + export country data + form option data

import {
  Building2,
  Store,
  Beaker,
  Sparkles,
  Wheat,
} from "lucide-react";
import { INDUSTRY_IMAGES } from "./media";

export const INDUSTRIES = [
  { key: "tea_brands", icon: Building2, image: INDUSTRY_IMAGES.tea_brands },
  { key: "retail", icon: Store, image: INDUSTRY_IMAGES.retail },
  { key: "food", icon: Wheat, image: INDUSTRY_IMAGES.food },
  { key: "nutraceutical", icon: Beaker, image: INDUSTRY_IMAGES.nutraceutical },
  { key: "cosmetics", icon: Sparkles, image: INDUSTRY_IMAGES.cosmetics },
];

// 4 primary export markets + Indonesia origin. Approximate lat/lng for map dots.
export const EXPORT_COUNTRIES = [
  { code: "TW", name: "Taiwan", coords: [120.9605, 23.6978] },
  { code: "PL", name: "Poland", coords: [19.1451, 51.9194] },
  { code: "DE", name: "Germany", coords: [10.4515, 51.1657] },
  { code: "MY", name: "Malaysia", coords: [101.9758, 4.2105] },
  { code: "ID", name: "Indonesia (Origin)", coords: [113.9213, -0.7893], isOrigin: true },
];

export const TEA_TYPE_OPTIONS = [
  "Green Tea",
  "Roasted Green Tea",
  "Black Tea (Orthodox)",
  "Black Tea (CTC)",
  "Oolong Tea",
  "Specialty Tea",
  "Custom Blend",
];

export const APPLICATION_OPTIONS = [
  "RTD Beverage",
  "Tea Bags",
  "Milk Tea / Bubble Tea",
  "Loose Leaf Retail",
  "Foodservice",
  "Food Ingredient",
  "OEM / Private Label",
  "Cosmetics / Nutraceutical",
];

export const PACKAGING_OPTIONS = [
  "Paper Sack",
  "Cartons",
  "Paper Sack + Cartons",
  "Custom / OEM packaging",
];

// Common countries for the Contact form country selector (top-ranked buyer markets)
export const CONTACT_COUNTRIES = [
  "United States", "Germany", "Japan", "Morocco", "United Arab Emirates",
  "United Kingdom", "France", "Australia", "Canada", "Netherlands",
  "Belgium", "Italy", "Spain", "Sweden", "Denmark", "Norway", "Finland",
  "Poland", "Czechia", "Austria", "Switzerland", "Ireland",
  "South Korea", "Singapore", "Malaysia", "Thailand", "Philippines",
  "Vietnam", "China", "Hong Kong", "Taiwan", "India", "Pakistan",
  "Saudi Arabia", "Qatar", "Kuwait", "Bahrain", "Oman", "Egypt", "Jordan",
  "Turkey", "Israel", "South Africa", "New Zealand",
  "Mexico", "Brazil", "Argentina", "Chile", "Colombia", "Peru",
  "Indonesia", "Other",
];
